import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import {
    Tabs, Box, Tab, Typography, ButtonGroup, Chip,
    Grid2 as Grid,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import ModalTitle from '../components/ModalTitle';
import QRCode from 'react-qr-code';
import { QrCode, QrCode2 } from '@mui/icons-material';




const WEBSITE = 'http://showtimeanafibj.web.app'
//const WEBSITE = 'http://localhost:3000'






export const QrCodeDialog = forwardRef(({ value }, ref) => {
    const [open, setOpen] = useState(false);
//    const [value, setValue] = useState(-1)






    useImperativeHandle(ref, () => {
        return {
            onShow(el) {
                setOpen(true);
//                setValue(el)
            }
        }
    })


    const handleClose = () => {
        setOpen(false);
    };






    return (
        <div>
            <Button size="small" variant="outlined" onClick={() => setOpen(true)} startIcon={<QrCode2 /> }></Button>
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth={true}>
                <DialogContent>
                    <QRCode
                        size={128}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={`${WEBSITE}/${value}/question`}
                        viewBox={`0 0 256 256`}
                    />
                    <Box>
                    <Button target="_blank" href={`${WEBSITE}/${value}/publiccatalog`} sx={{textTransform:'lowercase'}}>{`${WEBSITE}/${value}/publiccatalog`}</Button>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose}>chiudi</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
})



